module.exports = __webpack_public_path__ + "b72fa7d165d4f7951ea3a17c60515883.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/autodesk_2022_chart.png
// module id = 1637
// module chunks = 0